import { SET_FINAL_FORM } from './constants';

type State = {};

type Action = {
    +type: string,
    +payload: Object
};

const initialState = {};

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case SET_FINAL_FORM:
            return {
                ...state,
                [action.payload.namespace]: action.payload.finalForm
            };
        default:
            return state;
    }
}
